import $ from 'jquery';

function scrollToTop() {
    var last = scrollToTop.offset;
    scrollToTop.offset = document.documentElement.scrollTop || document.body.scrollTop;
    if (last < scrollToTop.offset && last !== 0) {
        window.cancelAnimationFrame(scrollToTop.frame);
        scrollToTop.offset = 0;
    }
    if (scrollToTop.offset > 0) {
        scrollToTop.frame = window.requestAnimationFrame(scrollToTop);
        window.scrollTo(0, scrollToTop.offset - scrollToTop.offset / 8);
    } else {
        scrollToTop.offset = 0;
    }
}

scrollToTop.offset = 0;

$('.metanav__link--back-to-top').on('click', function (e) {
    e.preventDefault();
    window.requestAnimationFrame(scrollToTop);
});
